import axios, {AxiosError, InternalAxiosRequestConfig} from 'axios';

import {ErrorResponse} from '@/domain';
import {API_URL} from '@/shared/config';
import {localizeHref} from '@/sync/lib/localizeHref';

import {TokenManager} from './tokenManager';
import {AxiosResponseInterceptor} from './types';

const tokenManager = new TokenManager();

export function getAuthTokenManager() {
  return tokenManager;
}

type ConfigureApiOptions = {
  getApiToken: () => string | null;
  onUnauthorized?: () => void | Promise<void>;
};

export function configureApi({
  getApiToken,
  onUnauthorized,
}: ConfigureApiOptions) {
  axios.defaults.baseURL = API_URL;
  axios.defaults.headers.common['X-App-Version'] = '2.5.0';

  tokenManager.addTokenSource(getApiToken);

  axios.interceptors.request.use(
    (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
      const token = tokenManager.getToken();
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    }
  );

  axios.interceptors.response.use(
    (response) => response,
    (error: AxiosError): Promise<AxiosError> => {
      // TODO: Think how to move this logic from here
      if (typeof window === 'undefined') {
        return Promise.reject(error);
      }

      const {response} = error;

      if (response && response.status === 409) {
        const data: ErrorResponse = response.data as ErrorResponse;
        switch (data.m) {
          case 'e_vpn':
            if (
              !window.location.pathname.includes(
                localizeHref('/:lang?/error-vpn')
              )
            ) {
              window.location.href = localizeHref('/:lang?/error-vpn');
            }
            break;
          case 'e_banned':
            window.location.href = `${localizeHref('/:lang?/error-banned')}?banId=${data.info.ban.id}&userId=${data.info.ban.user_id}&until=${data.info.ban.until}`;
            break;
        }

        console.error(response);
      } else if (response && response.status === 401) {
        (async () => {
          await onUnauthorized?.();
          window.location.href = localizeHref('/:lang?');
        })();
      }

      return Promise.reject(error);
    }
  );
}

export function addResponseInterceptors(
  interceptors: AxiosResponseInterceptor[]
) {
  interceptors.forEach(({onFulfilled, onRejected}) => {
    axios.interceptors.response.use(onFulfilled, onRejected);
  });
}
